// MB PAY VIA — bilingual site copy. CN = default.
export const CONTENT = {
  cn: {
    nav: {
      links: [
        { id: "pricing", label: "费率" },
        { id: "solutions", label: "解决方案" },
        { id: "benefits", label: "优势" },
        { id: "contact", label: "联系" },
      ],
      cta: "申请专属费率",
    },
    hero: {
      pill: "限时活动 · 2026年12月31日前加入并成功获批，可锁定长期优惠费率",
      badge: "限时活动",
      badgeSub: "优惠费率最低 0.9%",
      h1a: "高消耗虚拟卡",
      h1b: "专属费率",
      sub: "广告预算越大，更应该使用适合自己规模的支付方案。",
      desc: "MB PAY VIA 为广告主、Media Buyer、Agency 及高消耗团队提供专属虚拟卡费率方案。",
      lockLine: "2026年12月31日前加入并成功获批，可锁定对应的长期优惠费率。",
      ctaPrimary: "申请专属费率",
      ctaSecondary: "查看费率",
      whatsappBtn: "WhatsApp 联系客服",
      telegramBtn: "Telegram 联系客服",
    },
    marquee: ["Facebook Ads", "Google Ads", "TikTok Ads", "AI Tools", "Online Payments", "E-commerce"],
    compare: {
      tag: "费率对比",
      title: "还在使用普通费率？",
      desc: "如果你的每月消耗已经越来越高，就不应该一直使用普通客户的费率。MB PAY VIA 根据每月交易消耗量提供专属优惠方案。",
      standardTag: "普通用户",
      standardRate: "1.8%",
      standardLabel: "普通费率",
      standardPoints: ["适合一般使用客户", "统一标准费率", "消耗增长，费率不变"],
      vipTag: "高消耗客户",
      vipPrefix: "最低",
      vipRate: "0.9%",
      vipLabel: "专属优惠费率",
      vipPoints: ["按每月消耗量阶梯定价", "高消耗客户可申请专属费率", "专属客服协助申请"],
      foot: "达到指定月消耗量后，可联系客服申请专属优惠方案。",
      cta: "查询我的费率",
    },
    pricing: {
      tag: "阶梯费率",
      title: "专属阶梯优惠费率",
      subtitle: "不同月消耗等级可申请对应的专属优惠费率。",
      monthlySpend: "每月消耗",
      plans: [
        {
          spend: "USD 50,000 以下",
          rate: "1.8%",
          label: "普通费率",
          desc: "适合一般使用客户。",
          cta: "开始使用",
        },
        {
          spend: "USD 50,000 – USD 99,999",
          rate: "1.5%",
          label: "专属优惠费率",
          desc: "需要联系客服申请优惠费率。",
          cta: "申请 1.5% 费率",
        },
        {
          spend: "USD 100,000 – USD 299,999",
          rate: "1.3%",
          label: "高消耗优惠费率",
          desc: "适合长期大量投放客户，需联系客服申请。",
          cta: "联系客服",
        },
        {
          spend: "USD 300,000 – USD 499,999",
          rate: "0.9%",
          label: "Premium 高消耗费率",
          badge: "最低费率",
          featured: true,
          desc: "达到此消耗区间的客户，可申请平台最低优惠费率。",
          cta: "解锁 0.9%",
        },
        {
          spend: "USD 500,000+",
          rate: "CUSTOM",
          rateText: "专属费率",
          label: "大客户专属方案",
          desc: "针对超高消耗客户，可联系客服获取定制费率及专属服务。",
          cta: "联系专属客服",
        },
      ],
      disclaimer:
        "所有优惠费率均需经过账户审核，并可能根据卡类型、用途、交易情况及实际月消耗量有所调整。最终优惠费率以 MB PAY VIA 客服审核结果为准。",
    },
    campaign: {
      tag: "限时活动",
      title: "2026年12月31日前加入",
      subtitle: "成功获批后，锁定长期优惠费率",
      desc: "在活动期间加入 MB PAY VIA，并成功申请到对应的优惠费率，即可按照账户条款继续使用该优惠方案。",
      countdownLabel: "距离优惠活动结束",
      steps: [
        { n: "01", t: "加入 MB PAY VIA" },
        { n: "02", t: "申请专属优惠费率" },
        { n: "03", t: "审核通过" },
        { n: "04", t: "锁定优惠方案" },
      ],
      bigLine: "现在加入，锁定你的费率",
      cta: "现在锁定我的费率",
    },
    savings: {
      tag: "节省测算",
      titleA: "一点费率差距",
      titleB: "可以省下很大的成本",
      subtitle: "对于高消耗广告主来说，支付费率会直接影响整体广告成本。",
      monthlySpend: "每月消耗",
      standardTitle: "普通费率",
      promoTitle: "优惠费率",
      estFee: "预计手续费",
      monthlySave: "每月可节省",
      annualSave: "一年潜在节省",
      saveUpTo: "每年最多可省",
      footnote: "以上为示例测算，实际费用取决于最终核准的费率与实际消耗量。",
    },
    whoFor: {
      tag: "适用对象",
      title: "为高消耗用户而设",
      cards: [
        { t: "广告主", d: "适合长期投放 Facebook、Google、TikTok 广告的企业。" },
        { t: "Media Buyer", d: "方便管理多个广告账户及支付卡。" },
        { t: "Advertising Agency", d: "适合管理多个客户广告预算及支付成本。" },
        { t: "高消耗团队", d: "适合每月消耗 USD 50K、100K、300K 或更高的团队。" },
      ],
    },
    useCases: {
      tag: "支付场景",
      titleA: "一个平台",
      titleB: "多个支付场景",
      desc: "根据不同的支付需求，选择适合的虚拟卡方案。",
      items: ["Facebook Ads", "Google Ads", "TikTok Ads", "AI 订阅", "SaaS", "E-commerce", "Online Services", "Digital Payments"],
    },
    why: {
      tag: "平台优势",
      title: "为什么选择 MB PAY VIA？",
      cards: [
        { t: "专属阶梯费率", d: "符合条件的高消耗客户，可申请专属优惠方案。" },
        { t: "多种虚拟卡方案", d: "根据不同支付场景选择合适的卡。" },
        { t: "USDT Wallet 充值", d: "支持 USDT TRC20 Wallet Funding。" },
        { t: "多卡管理", d: "一个平台管理多个支付场景。" },
        { t: "专属客服", d: "高消耗客户可获得专属客服协助。" },
      ],
    },
    contact: {
      tag: "联系客服",
      title: "你的每月消耗是多少？",
      subtitle: "选择你的每月预估消耗，客服会根据你的情况推荐适合的费率方案。",
      spendLabel: "每月消耗范围",
      spendOptions: ["USD 50K 以下", "USD 50K – USD 100K", "USD 100K – USD 300K", "USD 300K – USD 500K", "USD 500K+"],
      usageLabel: "主要用途",
      usageOptions: ["Facebook Ads", "Google Ads", "TikTok Ads", "AI / SaaS", "E-commerce", "其他"],
      whatsappTitle: "WhatsApp 客服",
      whatsappBtn: "WhatsApp 联系客服",
      telegramTitle: "Telegram 客服",
      telegramBtn: "Telegram 联系客服",
      offerFrom: "优惠费率最低",
      offerJoin: "限期",
      offerJoinDate: "2026.12.31 前加入",
      offerApproved: "成功获批",
      offerLock: "锁定优惠费率",
      msgDefault: "你好 MB PAY VIA，我想申请高消耗专属优惠费率。",
      msgPrefix: "你好 MB PAY VIA，我想申请高消耗专属优惠费率。我的每月消耗约为：",
      msgUsage: "，主要用途：",
      msgSuffix: "。",
    },
    finalCta: {
      titleA: "不要再用普通费率",
      titleB: "跑高额预算",
      subtitle: "如果你的每月消耗已经具备规模，欢迎查询是否符合 MB PAY VIA 专属优惠方案资格。",
      from: "优惠费率最低",
      deadline: "2026年12月31日前加入",
      lock: "成功获批后锁定优惠方案",
      whatsapp: "WhatsApp 联系客服",
      telegram: "Telegram 联系客服",
    },
    footer: {
      tagline: "虚拟卡支付方案",
      menuTitle: "导航",
      menu: [
        { id: "pricing", label: "费率" },
        { id: "solutions", label: "解决方案" },
        { id: "benefits", label: "优势" },
        { id: "contact", label: "客服" },
      ],
      legalTitle: "条款",
      legal: [
        { key: "privacy", label: "隐私政策" },
        { key: "terms", label: "使用条款" },
        { key: "disclaimer", label: "免责声明" },
      ],
      contactTitle: "联系方式",
      disclaimerText:
        "所有费率、卡产品及服务供应情况，可能因卡类型、账户审核、交易类型、使用条件及每月消耗量不同而有所变化。所有优惠费率均以 MB PAY VIA 审核批准为准。",
      disclaimerExtra: "优惠费率须视账户状态、卡类型、使用情况及相关服务条款而定。",
      rights: "版权所有",
    },
    legal: {
      privacy: {
        title: "隐私政策",
        intro: "MB PAY VIA 尊重并保护用户隐私。本页面说明我们在提供服务过程中如何处理相关信息。",
        sections: [
          { h: "信息收集", p: "当你通过 WhatsApp、Telegram 或其他渠道联系 MB PAY VIA 时，我们可能会收集你主动提供的信息，例如联系方式、消耗规模及用途需求，用于评估与推荐适合的费率方案。" },
          { h: "信息用途", p: "收集的信息仅用于账户审核、费率方案推荐、客户服务及必要的风险控制，不会用于任何无关用途。" },
          { h: "信息共享", p: "除非法律法规要求或为完成服务所必需（例如合作卡组织或支付处理方），我们不会向无关第三方出售或共享你的个人信息。" },
          { h: "数据安全", p: "我们采取合理的商业与技术措施保护你的信息，防止未经授权的访问、披露或篡改。" },
          { h: "联系我们", p: "如对隐私政策有任何疑问，可通过 WhatsApp：+60 14-211 3390 或 Telegram：@Mbglobal96 与我们联系。" },
        ],
      },
      terms: {
        title: "使用条款",
        intro: "使用 MB PAY VIA 网站及相关服务，即表示你已阅读并同意以下条款。",
        sections: [
          { h: "服务说明", p: "MB PAY VIA 提供虚拟卡支付解决方案，包括多种虚拟卡方案、USDT TRC20 充值、多卡管理及客户支持等服务。" },
          { h: "账户与审核", p: "优惠费率需经 MB PAY VIA 审核，并可能根据卡类型、用途、交易情况及每月实际消耗量进行调整。用户应确保提供的信息真实、准确。" },
          { h: "费率说明", p: "页面所示费率（含 0.9%）为活动期间可申请的优惠费率范围，最终费率以审核批准结果及账户条款为准。" },
          { h: "活动期限", p: "2026年12月31日前加入并成功获批的用户，可按相应账户条款继续使用对应的优惠费率。" },
          { h: "责任限制", p: "在法律允许的最大范围内，MB PAY VIA 对因使用或无法使用本服务导致的间接损失不承担责任。" },
          { h: "联系我们", p: "如对条款有任何疑问，可通过 WhatsApp 或 Telegram 联系客服。" },
        ],
      },
      disclaimer: {
        title: "免责声明",
        intro: "本页面内容仅用于说明 MB PAY VIA 的服务与活动信息。",
        sections: [
          { h: "费率与审批", p: "页面展示的所有费率（包括 0.9%）均为可申请的优惠范围，实际费率取决于账户审核结果、卡类型、交易类型、使用条件及每月实际消耗量。" },
          { h: "服务可用性", p: "卡产品与服务可用性可能因地区、合作方及监管要求等因素有所变化。" },
          { h: "节省测算", p: "页面中的节省金额为基于示例数据的测算，仅用于说明费率差异的影响，不构成任何收益承诺。" },
          { h: "最终解释", p: "活动规则及最终费率以 MB PAY VIA 客服审核与解释为准。" },
        ],
      },
    },
  },

  en: {
    nav: {
      links: [
        { id: "pricing", label: "Pricing" },
        { id: "solutions", label: "Solutions" },
        { id: "benefits", label: "Benefits" },
        { id: "contact", label: "Contact" },
      ],
      cta: "Get Special Rate",
    },
    hero: {
      pill: "LIMITED TIME OFFER · Join & Get Approved Before 31 Dec 2026 · Secure Your Promotional Rate",
      badge: "LIMITED TIME OFFER",
      badgeSub: "Rates From 0.9%",
      h1a: "High Volume Virtual Card",
      h1b: "Pricing",
      sub: "Better pricing for serious monthly spending.",
      desc: "MB PAY VIA provides exclusive virtual card pricing for advertisers, media buyers, agencies and high-volume payment teams.",
      lockLine: "Join before 31 December 2026 and, once approved, secure your promotional rate for continued use.",
      ctaPrimary: "Get My Special Rate",
      ctaSecondary: "View Pricing",
      whatsappBtn: "Contact On WhatsApp",
      telegramBtn: "Chat On Telegram",
    },
    marquee: ["Facebook Ads", "Google Ads", "TikTok Ads", "AI Tools", "Online Payments", "E-commerce"],
    compare: {
      tag: "Rate Comparison",
      title: "Still Paying Standard Rates?",
      desc: "If your monthly spending is growing, you should not be paying the same rate as a normal user. MB PAY VIA offers exclusive pricing plans based on monthly transaction volume.",
      standardTag: "Standard User",
      standardRate: "1.8%",
      standardLabel: "Standard Rate",
      standardPoints: ["Suitable for regular users", "Flat standard rate", "Rate stays the same as you scale"],
      vipTag: "High Volume User",
      vipPrefix: "From",
      vipRate: "0.9%",
      vipLabel: "Exclusive Rate",
      vipPoints: ["Volume-based tiered pricing", "Qualified clients can apply for exclusive rates", "Dedicated support to apply"],
      foot: "Contact MB PAY VIA support to apply for a suitable high-volume pricing plan.",
      cta: "Check My Rate",
    },
    pricing: {
      tag: "Volume Pricing",
      title: "Exclusive Volume Pricing",
      subtitle: "Different monthly spending levels may qualify for different exclusive pricing plans.",
      monthlySpend: "Monthly Spend",
      plans: [
        {
          spend: "Below USD 50,000",
          rate: "1.8%",
          label: "Standard Rate",
          desc: "Suitable for regular users.",
          cta: "Get Started",
        },
        {
          spend: "USD 50,000 – USD 99,999",
          rate: "1.5%",
          label: "Special Volume Rate",
          desc: "Contact support to apply for this rate.",
          cta: "Apply For 1.5%",
        },
        {
          spend: "USD 100,000 – USD 299,999",
          rate: "1.3%",
          label: "Volume Rate",
          desc: "Suitable for consistent high-volume advertisers. Apply via support.",
          cta: "Contact Support",
        },
        {
          spend: "USD 300,000 – USD 499,999",
          rate: "0.9%",
          label: "Premium High Volume Rate",
          badge: "LOWEST RATE",
          featured: true,
          desc: "Clients in this range can apply for the platform's lowest promotional rate.",
          cta: "Unlock 0.9%",
        },
        {
          spend: "USD 500,000+",
          rate: "CUSTOM",
          rateText: "Custom Rate",
          label: "Dedicated Client Plan",
          desc: "For very high-volume clients, MB PAY VIA provides dedicated pricing and account support.",
          cta: "Talk To Dedicated Support",
        },
      ],
      disclaimer:
        "Exclusive promotional rates are subject to account review, card type, usage conditions and monthly transaction volume. Promotional pricing must be approved by MB PAY VIA support.",
    },
    campaign: {
      tag: "LIMITED TIME OFFER",
      title: "Join Before 31 December 2026",
      subtitle: "Secure Your Approved Promotional Rate",
      desc: "Join MB PAY VIA during the campaign period and successfully obtain an approved promotional rate. Once approved, your promotional rate can remain available for continued use according to the applicable account terms.",
      countdownLabel: "Offer Ends In",
      steps: [
        { n: "01", t: "Join MB PAY VIA" },
        { n: "02", t: "Apply For Your Exclusive Rate" },
        { n: "03", t: "Get Approved" },
        { n: "04", t: "Lock In Your Approved Rate" },
      ],
      bigLine: "JOIN NOW. KEEP YOUR RATE.",
      cta: "Lock My Rate Now",
    },
    savings: {
      tag: "Savings Example",
      titleA: "Small Rate Difference.",
      titleB: "Big Cost Difference.",
      subtitle: "For high-volume advertisers, even a small difference in payment fees can create significant savings.",
      monthlySpend: "Monthly Spend",
      standardTitle: "Standard Rate",
      promoTitle: "Premium Rate",
      estFee: "Estimated Fee",
      monthlySave: "Monthly Potential Savings",
      annualSave: "Annual Potential Savings",
      saveUpTo: "SAVE UP TO",
      footnote: "Illustration based on the example above. Actual fees depend on approved pricing and actual transaction volume.",
    },
    whoFor: {
      tag: "Who Is This For",
      title: "Built For High-Volume Users",
      cards: [
        { t: "Advertisers", d: "For businesses running large advertising budgets across Facebook, Google and TikTok." },
        { t: "Media Buyers", d: "Manage multiple advertising accounts and payment cards more efficiently." },
        { t: "Advertising Agencies", d: "Separate client spending and manage advertising payment costs." },
        { t: "High Volume Teams", d: "Designed for teams processing USD 50K, USD 100K, USD 300K or more every month." },
      ],
    },
    useCases: {
      tag: "Use Cases",
      titleA: "One Platform.",
      titleB: "Multiple Payment Scenarios.",
      desc: "Choose suitable virtual card solutions based on your payment requirements.",
      items: ["Facebook Ads", "Google Ads", "TikTok Ads", "AI Subscriptions", "SaaS", "E-commerce", "Online Services", "Digital Payments"],
    },
    why: {
      tag: "Why Us",
      title: "Why MB PAY VIA?",
      cards: [
        { t: "Exclusive Volume Pricing", d: "Qualified high-volume customers can apply for promotional pricing." },
        { t: "Multiple Virtual Card Options", d: "Different virtual card solutions are available for different payment scenarios." },
        { t: "USDT Wallet Funding", d: "Support for USDT TRC20 wallet funding." },
        { t: "Easy Card Management", d: "Manage multiple cards and payment scenarios from one platform." },
        { t: "Dedicated Support", d: "High-volume clients can contact our dedicated support team for suitable pricing plans." },
      ],
    },
    contact: {
      tag: "Contact",
      title: "How Much Do You Spend Every Month?",
      subtitle: "Tell us your estimated monthly spending and contact our support team to check which pricing plan may be suitable for you.",
      spendLabel: "Monthly Spending",
      spendOptions: ["Below USD 50K", "USD 50K – USD 100K", "USD 100K – USD 300K", "USD 300K – USD 500K", "USD 500K+"],
      usageLabel: "Main Usage",
      usageOptions: ["Facebook Ads", "Google Ads", "TikTok Ads", "AI / SaaS", "E-commerce", "Others"],
      whatsappTitle: "WhatsApp Support",
      whatsappBtn: "Contact On WhatsApp",
      telegramTitle: "Telegram Support",
      telegramBtn: "Chat On Telegram",
      offerFrom: "RATES FROM",
      offerJoin: "JOIN BEFORE",
      offerJoinDate: "31 DEC 2026",
      offerApproved: "GET APPROVED",
      offerLock: "LOCK YOUR RATE",
      msgDefault: "Hi MB PAY VIA, I'm interested in the high-volume rate.",
      msgPrefix: "Hi MB PAY VIA, I'm interested in the high-volume rate. My estimated monthly spending is ",
      msgUsage: ", main usage: ",
      msgSuffix: ".",
    },
    finalCta: {
      titleA: "Stop Paying Standard Rates",
      titleB: "For High-Volume Spending.",
      subtitle: "If you're already processing serious monthly volume, check whether you qualify for an MB PAY VIA promotional pricing plan.",
      from: "RATES FROM",
      deadline: "Join Before 31 December 2026",
      lock: "Lock In Your Approved Promotional Rate",
      whatsapp: "Contact On WhatsApp",
      telegram: "Chat On Telegram",
    },
    footer: {
      tagline: "Virtual Card Payment Solution",
      menuTitle: "Menu",
      menu: [
        { id: "pricing", label: "Pricing" },
        { id: "solutions", label: "Solutions" },
        { id: "benefits", label: "Benefits" },
        { id: "contact", label: "Support" },
      ],
      legalTitle: "Legal",
      legal: [
        { key: "privacy", label: "Privacy Policy" },
        { key: "terms", label: "Terms & Conditions" },
        { key: "disclaimer", label: "Disclaimer" },
      ],
      contactTitle: "Contact",
      disclaimerText:
        "Rates, card availability and service availability may vary depending on card type, account review, transaction type, usage conditions and monthly transaction volume. All promotional pricing is subject to approval by MB PAY VIA.",
      disclaimerExtra:
        "Promotional pricing remains subject to account status, card type, usage conditions and applicable service terms.",
      rights: "All rights reserved.",
    },
    legal: {
      privacy: {
        title: "Privacy Policy",
        intro: "MB PAY VIA respects and protects your privacy. This page explains how we handle information during the provision of our services.",
        sections: [
          { h: "Information We Collect", p: "When you contact MB PAY VIA via WhatsApp, Telegram or other channels, we may collect information you voluntarily provide, such as contact details, spending volume and usage requirements, in order to assess and recommend a suitable pricing plan." },
          { h: "How We Use Information", p: "Collected information is used only for account review, pricing plan recommendations, customer service and necessary risk control, and never for unrelated purposes." },
          { h: "Information Sharing", p: "Unless required by law or necessary to deliver the service (e.g. partner card schemes or payment processors), we do not sell or share your personal information with unrelated third parties." },
          { h: "Data Security", p: "We take reasonable commercial and technical measures to protect your information from unauthorized access, disclosure or alteration." },
          { h: "Contact Us", p: "For any questions about this policy, contact us on WhatsApp: +60 14-211 3390 or Telegram: @Mbglobal96." },
        ],
      },
      terms: {
        title: "Terms & Conditions",
        intro: "By using the MB PAY VIA website and related services, you agree to the following terms.",
        sections: [
          { h: "Service Description", p: "MB PAY VIA provides virtual card payment solutions, including multiple virtual card options, USDT TRC20 wallet funding, multi-card management and customer support." },
          { h: "Account & Review", p: "Promotional rates are subject to review by MB PAY VIA and may vary based on card type, usage, transaction conditions and actual monthly volume. Users must ensure the information they provide is true and accurate." },
          { h: "Rates", p: "Rates shown on the page (including 0.9%) represent the promotional range available during the campaign. Final rates are subject to approval and applicable account terms." },
          { h: "Campaign Period", p: "Users who join and are successfully approved before 31 December 2026 may continue to use the corresponding promotional rate according to the applicable account terms." },
          { h: "Limitation of Liability", p: "To the maximum extent permitted by law, MB PAY VIA shall not be liable for indirect losses arising from the use of or inability to use the service." },
          { h: "Contact Us", p: "For any questions about these terms, contact our support team via WhatsApp or Telegram." },
        ],
      },
      disclaimer: {
        title: "Disclaimer",
        intro: "The content on this page is for information about MB PAY VIA services and campaigns only.",
        sections: [
          { h: "Rates & Approval", p: "All rates shown (including 0.9%) represent an applicable promotional range. Actual rates depend on account review, card type, transaction type, usage conditions and actual monthly volume." },
          { h: "Service Availability", p: "Card products and service availability may vary due to region, partners and regulatory requirements." },
          { h: "Savings Illustrations", p: "Savings amounts shown are calculated from example data to illustrate the impact of rate differences only and do not constitute any guarantee of savings." },
          { h: "Final Interpretation", p: "Campaign rules and final approved rates are subject to review and interpretation by MB PAY VIA support." },
        ],
      },
    },
  },
};
